import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { toastr } from 'react-redux-toastr';

import SendEmail from '../components/pages/send-email';
import Actions from '../actions';
import UserAPI from '../apis/user';

import translations from '../../translations/app-translations';

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    locale: state.locale,
});

const mapDispatchToProps = (dispatch) => ({
    submitEmailForm: (formData, locale) => {
        dispatch(Actions.displayLoader());

        return UserAPI.sendEmail(formData).then(
            (response) => {
                dispatch(Actions.hideLoader());
                toastr.success(translations[locale]['send-success'], translations[locale]['send-email-success-1']);
                return true;
            },
            () => {
                toastr.error('Error', translations[locale]['send-email-failure']);
                dispatch(Actions.hideLoader());
                return false;
            },
        );
    },
});

const SendEmailConnector = connect(mapStateToProps, mapDispatchToProps)(SendEmail);

export default SendEmailConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/send-email-connector.js
 **/